
import { ComputedRef, PropType, ref } from "vue";
import { onMounted } from "@vue/runtime-core";
import store from "../../../repository/store/store";
import router from "../../../../src/routes";
import {
  dispatchErrorBox,
  formatBirthDate,
  isDecolaTemplate,
  maskCPF
} from "../mixins";
import { RepositoryException } from "../../../../domain/exceptions/exceptions";
import { User } from "../../../../domain/entities/entities";
import Suggestion from "../modals/Suggestion.vue";
import { Configuration } from "../../../../domain/entities/configuration";
import { computed } from "@vue/reactivity";
import PersonPhoto from "./data-table/PersonPhoto.vue";

export default {
  components: { PersonPhoto, Suggestion },
  methods: { formatBirthDate, maskCPF, isDecolaTemplate },
  props: {
    user: {
      type: Object as PropType<User>,
      required: true
    },
    interests: {
      type: Array,
      required: true
    }
  },

  setup() {
    const noCacheImage = ref();
    const showConfirmation = ref(false);

    const configuration: ComputedRef<Configuration> = computed(
      () => store.getters["configuration_module/configuration"] as Configuration
    );

    const user = computed(() => {
      return store.getters["userProfile_module/user"];
    });

    onMounted(async () => {
      await store.dispatch("userProfile_module/loadUser");
      const { image } = await store.getters["userProfile_module/user"];
      noCacheImage.value = image + "?_=" + Math.random();
    });

    function toDecoins(value: number | string) {
      value = Number(value);
      return Intl.NumberFormat("pt-br").format(value);
    }

    /** Makes the user name all lowercased and capitalized. */
    function capitalizeUserName(userName: string): string {
      const formattedName = userName.toLowerCase().split(" ");
      for (let i = 0; i < formattedName.length; i++) {
        formattedName[i] =
          formattedName[i].charAt(0).toUpperCase() +
          formattedName[i].substring(1);
      }
      return formattedName.join(" ");
    }

    const redoOnBoarding = async () => {
      try {
        await store.dispatch("userProfile_module/redoOnBoarding", true);
        await router.push({ name: "onboarding", params: { step: 1 } });
      } catch (e) {
        if (e instanceof RepositoryException) {
          await dispatchErrorBox(e.message);
        } else {
          console.error(e);
          await dispatchErrorBox("Ocorreu um erro inesperado.");
        }
      }
    };

    const closeSuggestionModal = () => {
      showConfirmation.value = false;
    };

    const openSuggestion = () => {
      showConfirmation.value = true;
    };

    const showButtonBoarding = (): boolean => {
      return process.env.VUE_APP_THEME != "circulo";
    };

    const hasCompany = computed(() => {
      return (
        Array.isArray(user.value.companies) &&
        user.value.companies.some(company => company.id > 0)
      );
    });

    return {
      noCacheImage,
      showConfirmation,
      configuration,
      hasCompany,
      capitalizeUserName,
      redoOnBoarding,
      toDecoins,
      showButtonBoarding,
      openSuggestion,
      closeSuggestionModal
    };
  }
};
